import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import './AgentInfo.css';

const AgentInfo = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    document.body.classList.remove('intro-active');
    document.body.style.overflow = 'auto';
    document.body.style.position = '';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const services = [
    { icon: '🏡', label: 'Real Estate Sales' },
    { icon: '💰', label: 'Mortgage Lending' },
    { icon: '📋', label: 'Escrow Services' },
    { icon: '🔑', label: 'Property Management' },
  ];

  return (
    <div className={`agent-info-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <Helmet>
        <title>About Truc Doan - Real Estate Agent in Westminster, CA</title>
        <meta name="description" content="Meet Truc Doan, your trusted real estate agent in Westminster, California. Specializing in Residential & Commercial Real Estate, Mortgage Loan, Escrow, and Rental Management with VUI GROUP." />
      </Helmet>

      <div className="agent-info-container">

        <div className="agent-hero">
          <button className="back-button" onClick={() => navigate('/')}>
            ← {t('nav.backToHome')}
          </button>
          <div className="agent-hero-inner">
            <div className="agent-photo-wrap">
              <img
                src="https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/20190818133635502+dropped.png"
                alt="Truc Doan - Real Estate Agent"
              />
            </div>
            <div className="agent-hero-text">
              <p className="agent-eyebrow">California Real Estate Professional</p>
              <h1>Truc Doan</h1>
              <p className="agent-tagline">Real Estate · Mortgage · Escrow · Property Management</p>
              <div className="agent-contact-row">
                <a href="mailto:doanestate@gmail.com" className="contact-pill">
                  <span>✉</span> doanestate@gmail.com
                </a>
                <a href="tel:8188180989" className="contact-pill">
                  <span>📞</span> (818) 818-0989
                </a>
                <span className="contact-pill muted">
                  <span>🪪</span> DRE #02060851 · VUI GROUP
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="services-strip">
          {services.map((s) => (
            <div key={s.label} className="service-chip">
              <span className="service-icon">{s.icon}</span>
              <span>{s.label}</span>
            </div>
          ))}
        </div>

        <div className="agent-bio-section">
          <div className="section-label">About</div>
          <p>
            Truc Doan is a distinguished name in California real estate, known for delivering a refined,
            full-service experience across real estate, mortgage lending, escrow, and property management.
            With a strong commitment to excellence, Truc provides clients with strategic guidance designed
            to maximize value at every stage of the real estate journey. Sellers benefit from expert
            positioning aimed at achieving the highest possible market price, while buyers receive skilled
            support in securing exceptional properties at the most favorable terms.
          </p>
          <p>
            By bringing real estate, financing, and escrow together in one seamless process, Truc offers
            a level of convenience, efficiency, and confidence that today's clients value. Every detail —
            from property search and negotiation to loan coordination and closing — is handled with
            professionalism, discretion, and care. Backed by deep market knowledge and a dedication to
            outstanding service, Truc Doan is a trusted partner for those seeking a sophisticated and
            successful real estate experience in California.
          </p>
          <p>
            Beyond sales and financing, Truc also offers professional property management services for
            short-term, mid-term, and long-term rentals, giving property owners a seamless solution for
            both acquisition and ongoing management.
          </p>
        </div>

        <div className="cta-section">
          <h2>Ready to get started?</h2>
          <p>Reach out today for a personalized consultation.</p>
          <div className="cta-buttons">
            <a href="mailto:doanestate@gmail.com?subject=Real Estate Inquiry" className="cta-button primary">
              Email Truc
            </a>
            <button
              onClick={() => { navigate('/'); setTimeout(() => window.dispatchEvent(new CustomEvent('openGlobeMap')), 100); }}
              className="cta-button secondary"
            >
              View Properties
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AgentInfo;